import React, { useEffect, useState } from 'react';
import '../Assets/Css/AddLabelModal.scss';
import Select from 'react-select';
import { customStyle } from './Style';
import { Modal, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import closeIcon from '../Assets/Images/Pop-Up/Close_button.svg'

function AddLabelModal({ isOpen, onClose, addTaskLabel,
  taskLabel,
  loading,
  deleteTaskLabel,
  deleteLoading,
  project,
  updateTaskLabel }) {
  const [labelName, setLabelName] = useState('');
  const [description, setDescription] = useState('');
  const [colorCode, setColorCode] = useState('#AD8D43');
  const [fieldValues, setFieldValues] = useState({});

  const [Fields, setFields] = useState({
    Project: '',
  });

  let Project = project?.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  useEffect(() => {
    const initialValues = {};

    taskLabel?.forEach((label) => {
      const selectedProject = Project?.find(
        (option) => option.value === label.project_id
      );
      initialValues[label.id] = selectedProject || '';
    });

    setFieldValues(initialValues);
  }, [taskLabel, project]);

  const colorOptions = [
    '#0057e7',
    '#d62d20',
    '#008744',
    '#ffa700',
    '#888888',
    '#7fe5f0',
    '#d11141',
    '#00b159',
    '#f37735',
    '#e3e4e5',
  ];


  const handleDelete = async (id) => {
    try {
      await deleteTaskLabel(id);
    } catch (error) {
      console.error("Error deleting task label: ", error);
    }
  };

  const handleAddLabel = async () => {
    try {
      if (!labelName || !Fields?.Project?.value || !colorCode) {
        toast.error("please fill all the required fields");
        return;
      }
      const body = {
        label_name: labelName,
        description,
        project_id: Fields?.Project?.value,
        color_code: colorCode
      }
      await addTaskLabel(body);
      setLabelName('');
      setDescription('');
      setFieldValues({
        Project: ''
      })
      setColorCode('#AD8D43');
    } catch (error) {
      console.error("Error in adding task category:", error);
    }

  };

  return (
    <>
      <Modal
        show={isOpen}
        onHide={onclose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="custom-modal"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5>Task Labels</h5>
            <button className="close-btn" onClick={onClose}>
              {<img src={closeIcon} alt="Close" />}
            </button>
          </div>
          <div className="modal-body">
            <table className="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Label Name</th>
                  <th>Description</th>
                  <th>Project</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {taskLabel?.map((item, index) => {
                  return (
                    <tr>
                      <td>{item?.id}</td>
                      <td>{item?.label_name}</td>
                      <td>{item?.description}</td>
                      <td>
                        <Select
                          value={fieldValues[item?.id]}
                          onChange={async (data) => {

                            setFieldValues((prev) => ({
                              ...prev,
                              [item?.id]: data,
                            }))
                            await updateTaskLabel(item?.id, { project_id: data?.value })
                          }
                          }
                          options={Project}
                          placeholder={'--'}
                          styles={customStyle}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: '#5757fe',
                              primary: '#5757fe',
                            },
                          })}
                        />
                      </td>
                      <td className="action-buttons">
                        <button onClick={() => handleDelete(item?.id)}>
                          {deleteLoading ? (<Spinner as="span" animation="border" role="status" aria-hidden="true" />) : "Delete"}</button>
                      </td>
                    </tr>
                  )
                })}

              </tbody>
            </table>

            <form className="form">
              <div className="row">
                <div className=" col-lg-6 col-md-6 col-sm-12">
                  <div className="form-group">
                    <label htmlFor="labelName">Label Name <span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      id="labelName"
                      value={labelName}
                      onChange={(e) => setLabelName(e.target.value)}
                    />
                  </div>
                </div>

                <div className=" col-lg-6 col-md-6 col-sm-12">
                  <div className="form-group">
                    <label htmlFor="labelName">Color Code</label>
                    <input
                      type="text"
                      id="labelName"
                      value={colorCode}
                      onChange={(e) => setColorCode(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-lg-6 col-md-12 ">
                  <label>Project <span style={{ color: 'red' }}>*</span></label>
                  <Select
                    value={Fields.Project}
                    onChange={(data) =>
                      setFields({
                        ...Fields,
                        Project: data,
                      })
                    }
                    options={Project}
                    placeholder={'--'}
                    styles={customStyle}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: '#5757fe',
                        primary: '#5757fe',
                      },
                    })}
                  />
                </div>

                <div className=" col-lg-6 col-md-6 col-sm-12 h-0 mt-3"></div>
                <div className=" col-lg-12 mt-3">
                  <div className="form-group">
                    <label htmlFor="description">Description</label>
                    <textarea
                      id="description"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Color Code</label>
                  <div className="color-picker">
                    {colorOptions.map((color) => (
                      <div
                        key={color}
                        className="color"
                        style={{ backgroundColor: color }}
                        onClick={() => setColorCode(color)}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button className="save-btn" onClick={onClose}>
              Close
            </button>
            <button className="save-btn" onClick={handleAddLabel}>
              {loading ? (<Spinner as="span" animation="border" role="status" aria-hidden="true" />) : "Save"}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default AddLabelModal;